const APP_NAME = 'AppBroker'
export class Logger {
  name?: string
  logger: (...args: any[]) => void
  constructor (logger: (...args: any[]) => void, name?: string) {
    this.name = name
    this.logger = logger
  }

  log (message: string, ...rest: any[]) {
    this.logger(`${APP_NAME}: ${this.name != null ? `[${this.name}]: ` : ''}${message}`, ...rest)
  }

  createLogger (name: string) {
    return new Logger(this.logger, [this.name, name].filter(i => i != null).join(':'))
  }
}
